import { Divider, Flex, Heading, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import DeleteConfirmationModal from '~/components/DeleteConfirmationModal';
import LinkButton from '~/components/LinkButton';
import Modal from '~/components/Modal/Modal';

const propTypes = {
  linkedRostersNames: PropTypes.arrayOf(PropTypes.string),
  onCancel: PropTypes.func,
};
const MediaPackDeleteModal = ({ linkedRostersNames, ...props }) => {
  if (linkedRostersNames?.length) {
    return (
      <Modal onClose={props.onCancel} {...props}>
        <Modal.Header />
        <Modal.CloseButton />
        <Modal.Body>
          <Text fontSize="md" marginBottom={2}>
            This Media Pack is linked to a Talent Roster
          </Text>
          <Text fontSize="md" marginBottom="2">
            You will need to ask your Talent Manager to remove this media pack
            from the following rosters before deleting it:
          </Text>
          <Flex
            as="ul"
            paddingLeft="6"
            fontSize="md"
            fontStyle="italic"
            direction="column"
          >
            {linkedRostersNames.map((roster) => (
              <Text key={roster} as="li">
                {roster}
              </Text>
            ))}
          </Flex>
        </Modal.Body>
        <Modal.Footer spaceBetween flexDirection="row-reverse">
          <LinkButton color="black" onClick={props.onCancel}>
            Dismiss
          </LinkButton>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <DeleteConfirmationModal {...props} confirmButtonText="Delete">
      <Heading fontSize="2xl" marginBottom={2}>
        Do you want to delete this Media Pack?
      </Heading>
      <Divider />
      <Text fontSize="md" marginTop={2}>
        Are you sure you want to delete this Media Pack? Once deleted, any
        clients you have shared this will lose access, and you will lose share
        count data.
      </Text>
    </DeleteConfirmationModal>
  );
};

MediaPackDeleteModal.propTypes = propTypes;
export default MediaPackDeleteModal;
